import { useTypedDispatch } from "../../stores/hooks";
import {
  PricingAnalysisFormState,
  patchPricingAnalysis,
} from "../../stores/slices/pricingAnalysisSlice";

interface PatchPricingHook {
  (): (payload: Partial<PricingAnalysisFormState>) => void;
}

export const usePatchPricing: PatchPricingHook = () => {
  const dispatch = useTypedDispatch();
  return (payload: Partial<PricingAnalysisFormState>) => {
    dispatch(patchPricingAnalysis(payload));
  };
};
